import { SuccessPageComponent } from './app-modules/success-page/success-page.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/services/auth-guard.service';

//Layouts
import { FullLayoutComponent } from './shared/components/layout/full-layout/full-layout.component';
import { SimpleLayoutComponent } from './shared/components/layout/simple-layout/simple-layout.component';
import { LoginComponent } from './app-modules/login';
import { PasswordResetComponent } from './app-modules/password-reset/password-reset.component';
import { ForgotPasswordComponent } from './app-modules/forgot-password/forgot-password.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        canActivate: [AuthGuard],
        pathMatch: 'full',
    },

    { path: "login", component: LoginComponent },
    { path: "success", component: SuccessPageComponent },
    { path: "passwordreset", component: PasswordResetComponent},
    { path: "forgotpassword", component: ForgotPasswordComponent},
    {
        path: '',
        component: FullLayoutComponent,
        canActivate: [AuthGuard],
        data: {
            title: 'Home'
        },
        children: [
            {
                path: 'home',
                loadChildren: './app-modules/home/home.module#HomeModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'accessgroup',
                loadChildren: './app-modules/access-group/access-group.module#AccessGroupModule'
            },
            {
                path: 'dashboard',
                loadChildren: './app-modules/dashboard/dashboard.module#DashboardModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'list/:entitytype',
                loadChildren: './app-modules/list/list.module#ListModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'detail',
                loadChildren: './app-modules/detail/detail.module#DetailModule',
                canActivate: [AuthGuard],

            },
            {
                path: 'detail/:entityid/:entityrecordid',
                loadChildren: './app-modules/detail/detail.module#DetailModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'detailpage/:entityrecordid',
                loadChildren: './app-modules/detail/detail.module#DetailModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'report',
                loadChildren: './app-modules/report/report.module#ReportModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'setup',
                loadChildren: './platform-tools/setup.module#SetupModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'play',
                loadChildren: './app-modules/play/play.module#PlayModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'settings',
                loadChildren: './app-modules/settings/settings.module#SettingsModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'report',
                loadChildren: './app-modules/report/report.module#ReportModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'view',
                loadChildren: './app-modules/view/view.module#ViewModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'view/:pagelayout',
                loadChildren: './app-modules/view/view.module#ViewModule',
                canActivate: [AuthGuard]
            },
            {
                path: 'view/:pagelayout/:entityid',
                loadChildren: './app-modules/view/view.module#ViewModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'view/:pagelayout/:entityid/:entityrecordid',
                loadChildren: './app-modules/view/view.module#ViewModule',
                canActivate: [AuthGuard],
            },
            {
                path: 'dynamic',
                loadChildren: './app-modules/dynamic/dynamic.module#DynamicModule',
                canActivate: [AuthGuard],
            }

        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthGuard]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.ts